import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { constUrpi } from '../helpers/constants';

interface IMenuItem {
  type: string,       // Possible values: link/dropDown/icon/separator/extLink
  name?: string,      // Used as display text for item and title for separator type
  state?: string,     // Router state
  icon?: string,      // Material icon name
  tooltip?: string,   // Tooltip text
  disabled?: boolean, // If true, item will not be appeared in sidenav.
  sub?: IChildItem[], // Dropdown items
  badges?: IBadge[],
  codeMenu?: string,
  evaluate?: boolean
}
interface IChildItem {
  type?: string,
  name: string,       // Display text
  state?: string,     // Router state Software Engineer
  icon?: string,
  sub?: IChildItem[]
}

interface IBadge {
  color: string;      // primary/accent/warn/hex color codes(#fff000)
  value: string;      // Display text
}

@Injectable()
export class NavigationService {
  constructor() { }

  defaultMenu: IMenuItem[] = [
    {
      name: 'DASHBOARD',
      type: 'link',
      tooltip: 'Dashboard',
      icon: 'dashboard',
      state: 'dashboard'
    }
  ]
  separatorMenu: IMenuItem[] = [
    {
      name: 'DASHBOARD',
      type: 'link',
      tooltip: 'Dashboard',
      icon: 'dashboard',
      state: 'dashboard'
    },
  ]
  iconMenu: IMenuItem[] = [
    {
      name: 'Prospectos',
      type: 'link',
      tooltip: 'Prospectos',
      icon: 'format_list_bulleted',
      state: 'prospecto',
      codeMenu: constUrpi.module.prospectoWeb,
      evaluate: true
    },
    {
      name: 'Administración de equipos y perfiles',
      type: 'dropDown',
      tooltip: 'Administración de equipos y perfiles',
      icon: 'phonelink_setup',
      state: '',
      codeMenu: constUrpi.module.admPerfilWeb,
      evaluate: true,
      sub: [
        { name: 'Equipos y perfiles', state: 'administrador/perfil-listar' }
        //{ name: 'Bandeja de solicitudes pendientes', state: 'administrador/solicitud-pendiente-listar' }
      ]
    },
    {
      name: 'Administración y carga de visitas',
      type: 'link',
      tooltip: 'Administración y carga de visitas',
      icon: 'cloud_upload',
      state: 'visita',
      codeMenu: constUrpi.module.visitasWeb,
      evaluate: true
    },
    {
      name: 'Administración notificaciones',
      type: 'dropDown',
      tooltip: 'Administración notificaciones',
      icon: 'notifications',
      state: '',
      codeMenu: constUrpi.module.notifWeb,
      evaluate: true,
      sub: [
        { name: 'Registrar notificación', state: 'notificacion/registrar' },
        { name: 'Buscar notificacion', state: 'notificacion/listar' }
      ]
    },
    {
      name: 'Procesamiento roles y perfiles',
      type: 'link',
      tooltip: 'Procesamiento roles y perfiles',
      icon: 'cloud_upload',
      state: 'procesamiento-rol-perfil',
      codeMenu: constUrpi.module.proRropeWeb,
      evaluate: true
    }
  ]

  // Icon menu TITLE at the very top of navigation.
  // This title will appear if any icon type item is present in menu.
  iconTypeMenuTitle: string = 'Acceso Frecuente';
  // sets iconMenu as default;
  menuItems = new BehaviorSubject<IMenuItem[]>(this.iconMenu);
  // navigation component has subscribed to this Observable
  menuItems$ = this.menuItems.asObservable();

  cargarMenuLateral(menu: any): any {
    var listaFiltrada = [];
    this.menuItems.forEach(menuItem =>{
      for (var i = 0; i < menuItem.length; i++) {
        var o = menuItem[i];
        if (o.evaluate) {
          menu.forEach(element => {
            if (element.menuCodigo == o.codeMenu) {
              o.name = element.menuDescripcion;
              o.tooltip = element.menuDescripcion;
              listaFiltrada.push(o);
            }
          });
        } else {
          listaFiltrada.push(o);
        }
      }
    });
    return listaFiltrada;
  }

  // Customizer component uses this method to change menu.
  // You can remove this method and customizer component.
  // Or you can customize this method to supply different menu for
  // different user type.
  publishNavigationChange(menuType: string) {
    switch (menuType) {
      case 'separator-menu':
        this.menuItems.next(this.separatorMenu);
        break;
      case 'icon-menu':
        this.menuItems.next(this.iconMenu);
        break;
      default:
        this.menuItems.next(this.defaultMenu);
    }
  }

  validarAccesoMenu(): boolean{
    return true;
  }
}
